import { render, staticRenderFns } from "./UserGroupEditForm.vue?vue&type=template&id=02cccb32"
import script from "./UserGroupEditForm.vue?vue&type=script&lang=js"
export * from "./UserGroupEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports